/**
 * The restriction options for a [[SubscriptionBillingOptionPrice]].
 */
export var SubscriptionBillingOptionPriceRestriction;
(function (SubscriptionBillingOptionPriceRestriction) {
    /**
     * Redemption of the specified [[DiscountSubscriptionBillingOptionPrice.discountId]] is required.
     */
    SubscriptionBillingOptionPriceRestriction["Discount"] = "Discount";
})(SubscriptionBillingOptionPriceRestriction || (SubscriptionBillingOptionPriceRestriction = {}));
//# sourceMappingURL=subscription-billing-option-price-restriction.js.map